<template>
  <div class="flex flex-col">
    <h2>Usuarios</h2>

    <router-link
      v-if="hasPermission('edit_admins')"
      :to="{ name: 'usersCreateForm' }"
      class="primary-button mx-0 mt-2"
      >Crear Usuario</router-link
    >

    <custom-search
      class="mt-6 w-full sm:w-[500px]"
      placeholder="Buscar por Nombre"
      v-model="searchText"
      @confirm="search"
      @clear="search"
    />

    <div class="card mt-6">
      <table class="table-auto text-sm mt-2 bg-white">
        <thead class="text-left">
          <tr class="bg-gray-100">
            <th class="p-2 rounded-l-lg">ID</th>
            <th class="p-2">Nombre</th>
            <th class="p-2">Correo</th>
            <th class="p-2">Rol</th>
            <th class="p-2 rounded-r-lg">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in users" :key="user.id" class="table-row">
            <td class="table-cell">
              {{ user.id }}
            </td>
            <td class="table-cell">{{ user.name }} {{ user.last_name }}</td>
            <td class="table-cell">
              {{ user.user.email }}
            </td>
            <td class="table-cell">
              {{
                user.user.role
                  ? user.user.role.name
                  : user.is_super
                  ? "Super Admin"
                  : ""
              }}
            </td>

            <td class="table-cell">
              <div class="flex">
                <router-link
                  :to="{
                    name: 'usersDetail',
                    params: { id: user.id },
                  }"
                  class="secondary-button"
                  >Detalle</router-link
                >
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="loading" class="flex w-full h-full items-center">
        <loader-icon class="h-10 w-10 text-primary-500 mx-auto"></loader-icon>
      </div>
    </div>

    <pagination
      :current-page="currentPage"
      :total-pages="totalPages"
      @page-change="onPageChange"
    />
  </div>
</template>

<script>
import api from "@/api";
import Pagination from "@/components/ui/Pagination.vue";
export default {
  name: "Users",

  components: {
    Pagination,
  },

  data() {
    return {
      users: null,
      loading: false,
      searchText: "",
      currentPage: 1,
      totalPages: 0,
    };
  },

  created() {
    this.$store.commit("setSelectedTab", "users");

    this.loadUsers();
  },

  methods: {
    async loadUsers() {
      this.loading = true;

      try {
        const response = await api.users.getAllWithQueryParams([
          {
            name: "page",
            value: this.currentPage,
          },
          {
            name: "search",
            value: this.searchText,
          },
        ]);
        this.users = response.data;
        this.currentPage = response.current_page;
        this.totalPages = response.last_page;
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loading = false;
    },

    search() {
      this.currentPage = 1;
      this.loadUsers();
    },

    onPageChange(page) {
      this.currentPage = page;
      this.loadUsers();
    },
  },
};
</script>